import {Component, OnInit} from '@angular/core';
import {IdleDialogComponent} from "../idle-dialog/idle-dialog.component";
import {FacadeService} from "../../service-facade/facade.service";
import {BnNgIdleService} from "bn-ng-idle";
import {MatDialog, MatDialogState} from "@angular/material/dialog";
import {ApplicationLogsRequest} from "leia-api";
import {Router} from "@angular/router";
import {SignupService} from "../../../signup/service/signup.service";
import StatusEnum = ApplicationLogsRequest.StatusEnum;
import { SESSION_IDLE_URL_KEY } from '../../constants';
import {HomepageEnum} from "../../model/homepage.enum";

@Component({
  selector: 'app-session-idle',
  templateUrl: './session-idle.component.html',
  styleUrls: ['./session-idle.component.css']
})
export class SessionIdleComponent implements OnInit {

  dialogRef : any;

  constructor(private facadeService: FacadeService, private bnIdle: BnNgIdleService, private dialog: MatDialog, private signupService: SignupService, public router: Router) { }

  ngOnInit(): void {
    //  SESSION TIMEOUT IMPLEMENTATION
    //  Monitor for session idle - when detected - inform the user via Angular Material Dialog
    let idleTimeoutInSecondsAsString : string = this.facadeService.getStorageItem("idle-timeout-in-seconds");

    let idleTimeoutInSeconds : number = parseInt(idleTimeoutInSecondsAsString);

    let idleTimeoutUntilRedirectInSecondsAsString : string = this.facadeService.getStorageItem("idle-timeout-until-redirect-in-seconds");

    let idleTimeoutUntilRedirectInSeconds : number = parseInt(idleTimeoutUntilRedirectInSecondsAsString);

    let dialogIsVisible = false;
    let idleSecondsPassed : number = 0;

    //  If we have determined a valid idle time - register the Idle Service to monitor.
    if(idleTimeoutInSeconds != null && idleTimeoutInSeconds > 0) {
      this.bnIdle.startWatching(idleTimeoutInSeconds).subscribe((res) => {

        if(!res || (this.dialogRef !== undefined && this.dialogRef.getState() === MatDialogState.OPEN)) {
          return;
        }
        let applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();
        if(applicationRequest.status === StatusEnum.Approved || applicationRequest.status === StatusEnum.Rejected) {
          return this.performIdleRedirect();
        }

        this.dialogRef = this.dialog.open(IdleDialogComponent, {
          width: "500px",
          position: {
            top: '20px'
          },
          disableClose: false,
          hasBackdrop: true
        });

        //  Set a function to track how long they have been sitting on the session timeout dialog.
        //  Once they have exceeded the timeout until redirect - send them to the redirect URL.
        let selfReference = this;
        let idleTimeout = setInterval(function () {
          if (!dialogIsVisible) {
            return;
          }

          idleSecondsPassed++;
          if(idleSecondsPassed >= idleTimeoutUntilRedirectInSeconds) {
            selfReference.performIdleRedirect();
          }
        }, 1000); // Interval = 1 second.

        this.dialogRef.afterOpened().subscribe(() => {
          dialogIsVisible = true;
          this.signupService.idleDialogVisible = true;

          idleSecondsPassed = 0;
          this.bnIdle.resetTimer();
        });

        this.dialogRef.afterClosed().subscribe(() => {
          dialogIsVisible = false;
          this.signupService.idleDialogVisible = false;

          idleSecondsPassed = 0;
          this.bnIdle.resetTimer();
          clearInterval(idleTimeout);
        });
      });
    }
  }

  performIdleRedirect() : void {
    window.location.href = this.facadeService.getStorageItem(SESSION_IDLE_URL_KEY) ?? HomepageEnum.TCB;
  }
}
